import { FormEvent, useState } from 'react';

type FormState = 'idle' | 'loading' | 'success' | 'error';

const interests = [
  'VS Code extension user',
  'Hardware Dev Kit interest',
  'Business / bulk interest',
  'Embedded / robotics / industrial use',
  'Automotive diagnostics use'
];

export function WaitlistPage() {
  const [state, setState] = useState<FormState>('idle');
  const [error, setError] = useState('');
  const [lastSubmitAt, setLastSubmitAt] = useState(0);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [useCase, setUseCase] = useState('');
  const [interest, setInterest] = useState('');
  const [message, setMessage] = useState('');

  async function submit(event: FormEvent) {
    event.preventDefault();

    if (state === 'loading' || Date.now() - lastSubmitAt < 3000) return;

    if (!email.includes('@') || !interest) {
      setError('Email and interest are required.');
      setState('error');
      return;
    }

    setState('loading');
    setError('');
    setLastSubmitAt(Date.now());

    try {
      const response = await fetch('/api/waitlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, useCase, interest, message })
      });
      const result = await response.json().catch(() => ({ error: 'Waitlist submission failed.' }));

      if (!response.ok || !result.ok) {
        throw new Error(result.error || 'Waitlist submission failed.');
      }

      setState('success');
      setName('');
      setEmail('');
      setUseCase('');
      setInterest('');
      setMessage('');
    } catch (submitError) {
      setError(submitError instanceof Error ? submitError.message : 'Waitlist submission failed.');
      setState('error');
    }
  }

  return (
    <main className="section waitlist-page">
      <div className="waitlist-copy">
        <p className="eyebrow">SmartCAN Pro Dev Kit</p>
        <h1>Join the waitlist</h1>
        <p className="lead">
          SmartCAN Pro Dev Kit is in active development. Join the waitlist for hardware beta interest, team workflows, and developer tooling updates.
        </p>
        <div className="value-list">
          <span>VS Code CAN analysis</span>
          <span>High-rate USB live monitoring</span>
          <span>Wi-Fi snapshot mode</span>
          <span>CANLOG01 exports</span>
        </div>
        <div className="account-preview">
          <p className="eyebrow">Account / Login coming soon</p>
          <h2>No fake login</h2>
          <p>Backend auth is not enabled for this web app yet. Planned account features include hardware beta access, device registration, download history, and SDK keys if needed later.</p>
        </div>
        <div className="dns-note">
          <p className="eyebrow">DNS reminder</p>
          <code>Type: A</code>
          <code>Name: smartcan</code>
          <code>Value: 76.76.21.21</code>
          <code>TTL: Auto</code>
        </div>
      </div>

      <form className="waitlist-form" onSubmit={submit}>
        <h2>Waitlist request</h2>
        <label>Name<input value={name} onChange={(event) => setName(event.target.value)} autoComplete="name" /></label>
        <label>Email<input value={email} onChange={(event) => setEmail(event.target.value)} type="email" autoComplete="email" /></label>
        <label>Interest
          <select value={interest} onChange={(event) => setInterest(event.target.value)} required>
            <option value="">Select interest</option>
            {interests.map((item) => <option key={item} value={item}>{item}</option>)}
          </select>
        </label>
        <label>Use case<input value={useCase} onChange={(event) => setUseCase(event.target.value)} placeholder="Embedded, robotics, fleet, industrial..." /></label>
        <label>Message<textarea value={message} onChange={(event) => setMessage(event.target.value)} rows={5}></textarea></label>
        <button className="button primary" disabled={state === 'loading'} type="submit">{state === 'loading' ? 'Submitting...' : 'Submit waitlist request'}</button>
        {state === 'success' && <p className="success-text">Request received. We will follow up when the Dev Kit beta and account features are ready.</p>}
        {state === 'error' && <p className="error-text">{error}</p>}
        <p className="panel-note">Submissions go to the SmartCAN waitlist API. Production notification requires Resend or SendGrid environment variables on Vercel.</p>
      </form>
    </main>
  );
}
